module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter01"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter01"
    }
  }, [_vm._v("1: THE STRANGER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter02"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter02"
    }
  }, [_vm._v("2: LIKE CINDERELLA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter03"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Chapter03"
    }
  }, [_vm._v("3: A SECRET SHARED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter04"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: MUTUAL RESPONSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter05"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: WHAT OUR MEMORIES ARE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter06"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: THE BRIGHT MORNING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter07"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: BIOGRAPHICAL DETAILS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter08"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: BLOSSOMING OUT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter09"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: NOT TO BE HARNESSED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: THE TWO CRUSOES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: A FLIRTATION, BY DOCTOR’S ORDERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: ON THE BALCONY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: THE LADY OF THE CAMELLIAS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter14"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: WELCOME HOME!")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter15"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: SPEAKING OF SECOND MARRIAGES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter16"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: A REMINDER OF JOY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter17"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17: A REBEL INDEED")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter18"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18: A LUCKY BREAK FOR CHARLOTTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter19"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19: A GIRLHOOD FRIEND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter20"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20: A QUESTION OF TABOOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter21"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21: J.D. AGAIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter22"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22: AN UGLY WORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter23"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23: THE KNELL OF FOREVER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter24"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24: THE HEIRESS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter25"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25: CONSULTATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter26"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26: A TALL DARK LADY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter27"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27: IN PLACE OF A NURSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter28"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28: THE DAUGHTER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rchapter29"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29: THE CRUCIAL TEST")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter01"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry",
    attrs: {
      "id": "rbackmatter02"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Workscited",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WORKS CITED")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 72
// module chunks = 0